export function canAccessTeamAudit(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true && user.role === 'admin') return true;
  const slug = String(user.currentPlan?.slug || '').toLowerCase();
  const hasEmployeeAccounts = Boolean(
    user.unlockedFeatures?.employeeAccounts || user.currentPlan?.features?.employeeAccounts
  );
  const isOwner = user.role !== 'employee';
  return ['empresarial', 'enterprise', 'business'].includes(slug) && hasEmployeeAccounts && isOwner;
}
